import React from "react";
import parse, {
  domToReact,
  Element,
  HTMLReactParserOptions,
} from "html-react-parser";
import { twMerge } from "tailwind-merge";

const HeadingRenderer = ({
  value,
  className,
}: {
  value: string;
  className?: string;
}) => {
  type TagName = "h1" | "h2" | "h4";

  const tagStyles: { [key in TagName]: string } = {
    // When editing styles, temporarily extract desired tag styles to a variable called className to get auto-complete
    h1: "font-heading text-4xl font-bold italic text-armyGreen md:text-6xl lg:text-7xl lg:leading-[110%] [&_strong]:font-extrabold",
    h2: "font-heading text-[28px] font-bold italic tracking-[1.12px] text-darkText md:text-3xl lg:text-4xl lg:leading-[110%] lg:tracking-[1.44px] [&_strong]:font-extrabold",
    h4: "font-semibold tracking-wide text-darkPurple md:text-2xl lg:text-[28px] lg:tracking-[0.56px]",
  };

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.name in tagStyles) {
        const tagName = domNode.name as TagName; // Type assertion
        const mergedClass = twMerge(tagStyles[tagName], className);
        return React.createElement(
          tagName,
          { className: mergedClass },
          domToReact(domNode.children, options)
        );
      }
    },
  };

  return <>{parse(value, options)}</>;
};

export default HeadingRenderer;
